import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  accountQuery,
  buildCasinoGameFilters,
  casinoVendorsQuery,
  useAuthSession,
} from '@/api';
import { CasinoChrome } from './CasinoChrome';
import { ProvidersPanel } from './ProvidersPanel';

export function CasinoProvidersPage() {
  const { user } = useAuthSession();
  const { data: account } = useQuery(accountQuery());
  const filters = useMemo(
    () => buildCasinoGameFilters({ account, user, category: 'slots', casino: true }),
    [account, user],
  );
  const vendorsQuery = useQuery(casinoVendorsQuery(filters));

  return (
    <CasinoChrome activeNavId="lobby" showCategoryNav={false} providersActive>
      <h1 className="text-heading-m text-text-primary">Providers</h1>
      <ProvidersPanel
        vendors={vendorsQuery.data ?? []}
        isLoading={vendorsQuery.isLoading}
        category="slots"
      />
    </CasinoChrome>
  );
}
